import { Commit } from 'vuex';
import Vue from 'vue';
import { OccupancyReports } from '@/interfaces/reports';

interface OccupancyState {
	occupancies: {
		[id: number]: OccupancyReports;
	};
}

export interface OccupancyParams {
	devices: string[];
	start: string;
	end: string;
}

export default {
	namespaced: true,
	state: {
		occupancies: {},
	} as OccupancyState,
	getters: {
		getOccupancies: (state: OccupancyState): { [id: number]: OccupancyReports } => {
			return state.occupancies;
		},

		getOccupancy:
			(state: OccupancyState) =>
			(id: number): OccupancyReports => {
				return state.occupancies[id];
			},
	},
	mutations: {
		SET_OCCUPANCY(state: OccupancyState, occupancy: OccupancyReports): void {
			const oldOccupancy = state.occupancies[occupancy.device![0]] || {};
			state.occupancies = {
				...state.occupancies,
				[occupancy.device![0]]: { ...oldOccupancy, ...occupancy },
			};
		},

		CLEAN_OCCUPANCIES(state: OccupancyState): void {
			state.occupancies = {};
		},
	},
	actions: {
		async fetchOccupancies(
			{ commit }: { commit: Commit },
			{ params }: { params: OccupancyParams }
		): Promise<void> {
			const queryParams = new URLSearchParams();
			for (const devices of params.devices) {
				queryParams.append('devices', devices);
			}
			queryParams.append('start', params.start);
			queryParams.append('end', params.end);
			queryParams.append('useMap', 'True');

			const response = await Vue.axios.get(
				`${process.env.VUE_APP_API_URL}/lighting/reports/occupancy/`,
				{ params: queryParams }
			);
			if (response && response.status === 200) {
				for (const response_data of response.data.data) {
					if ((response_data as OccupancyReports).device instanceof Array) {
						commit('SET_OCCUPANCY', response_data);
					}
				}
			}
		},

		cleanAllOccupancies({ commit }: { commit: Commit }): void {
			commit('CLEAN_OCCUPANCIES');
		},
	},
};
